export function createParticipantsMethods(api) {
    return {
        async listMembers(campaignId) {
            const {data} = await api.gamemasterCampaignsMembersRetrieve(campaignId);
            return data;
        },

        /**
         * @param {string} campaignId
         * @param {string} clientId
         * @param {'master'|'player'} role
         */
        async addMember(campaignId, clientId, role) {
            const {data} = await api.gamemasterCampaignsMembersCreate(campaignId, {client_id: clientId, role});
            return data;
        },

        /**
         * The generated signature is `(clientId, id, role)` — the path substitutes
         * `{client_id}` from the first argument. This is not a swapped-argument bug.
         */
        async removeMember(campaignId, clientId, role) {
            await api.gamemasterCampaignsMembersDestroy(clientId, campaignId, role);
        },
    };
}
